<template>
  <div id="app">
    <keep-alive>
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
@import "../node_modules/xep-ui/lib/xep-ui.css";
* {
  margin: 0;
  padding: 0;
}
</style>
